<template>
  <div class="accounting-document-amount-renderer">
    <div class="unit" :class="textColor">
      <span v-for="i in 9" :key="i" :class="[i===2||i===5?'blue':'',i===9?'pink':'']">{{ getNumber(9-i) }}</span>
      <span>{{ amountRight[0] }}</span>
      <span>{{ amountRight[1] }}<span /></span></div>
  </div>
</template>

<script>
import Vue from 'vue'
export default Vue.extend({
  name: 'AccountingDocumentAmountRenderer',
  data() {
    return {
      value: '',
      amountLeft: '',
      amountRight: ''
    }
  },
  computed: {
    textColor() {
      const { value } = this.params
      if (value < 0) {
        return 'red'
      }
      return ''
    }
  },
  watch: {
    value: function(val, oldVal) {
      if (val && val !== oldVal) {
        const splitValue = String(val).replace('-', '').split('.')
        const amountLeft = splitValue[0]
        if (amountLeft.length > 9) {
          this.amountLeft = '999999999'
        } else {
          this.amountLeft = amountLeft
        }
        this.amountRight = splitValue.length > 1 ? splitValue[1] : '00'
      } else {
        this.amountLeft = ''
        this.amountRight = ''
      }
    }
  },
  mounted() {
    this.value = this.params.value
  },
  methods: {
    refresh() {
      return false
    },
    getNumber(index) {
      const length = this.amountLeft.length
      return this.amountLeft[length - index - 1] || ''
    }
  }
})
</script>

<style lang="scss">
.accounting-document-amount-renderer{
  height: 100%;
  .unit{
    display: flex;
    justify-content: space-between;
    height: 100%;
    &.red{
      color: #de5889;
    }
    span{
      flex: 1;
      border-right: 1px solid #e6e6e6;
      text-align: center;
      height: 100%;
      &.blue{
        border-color:#a7d9f5;
      }
      &.pink{
        border-color:#eebbbb;
      }
      &:nth-last-child(1){
        border:none
      }
    }
  }
}

</style>
